export enum QueryOperation {
    next = 'next',
    top = 'top',
    previous = 'previous',
    refresh = 'refresh',
    query = 'query' 
}
